import { Injectable, Inject } from '@angular/core';
import { REPORT_PARAM_TRANSFORMERS } from './models';
import { LoggerService } from '@content-platform/web-angular-shared-util-logging';
import * as bowser from 'bowser';
import * as i0 from "@angular/core";
import * as i1 from "@content-platform/web-angular-shared-util-logging";
const ISSUE_REPORT_EMAIL_ADDRESS = 'prodapps@rt.mtvi.com';
const browser = bowser.getParser(window.navigator.userAgent);
const osInfo = browser.getOS();
const platformInfo = browser.getPlatform();
const browserInfo = browser.getBrowser();
export class IssueReportingService {
    constructor(loggerService, paramTransformers) {
        this.paramTransformers = paramTransformers;
        this.logger = loggerService.instance('IssueReportingService');
    }
    getOSString() {
        if (!osInfo) {
            return this.getPlatformString();
        }
        return (`${osInfo.name} ${osInfo.version} ${osInfo.versionName ? osInfo.versionName + ' ' : ''}` +
            this.getPlatformString());
    }
    getPlatformString() {
        if (!platformInfo) {
            return navigator.platform;
        }
        return (`${platformInfo.vendor ? platformInfo.vendor + ' ' : ''}` +
            `${platformInfo.model ? platformInfo.model + ' ' : ''}` +
            `(${platformInfo.type})`);
    }
    getBrowserString() {
        if (!browserInfo) {
            return navigator.appVersion;
        }
        return `${browserInfo.name} ${browserInfo.version}`;
    }
    getErrorString(error) {
        if (!error) {
            return undefined;
        }
        let errStr = error.message;
        if (error.error) {
            try {
                errStr += ' - ';
                errStr += JSON.stringify(error.error);
            }
            catch (jsonError) {
                // ignore
                console.log('Error stringifying error object:', jsonError);
            }
        }
        return errStr;
    }
    getIssueDetails(error) {
        let issueDetails = {
            Location: window.location.href,
            Version: this.logger.appVersion,
            Error: this.getErrorString(error),
            'Error Source': error ? error.source : undefined,
            'Operating System': this.getOSString(),
            'Browser Version': this.getBrowserString()
        };
        this.paramTransformers
            .filter(paramTransformer => paramTransformer.initialized)
            .forEach(transformer => {
            issueDetails = {
                ...issueDetails,
                ...transformer.getParams()
            };
        });
        return issueDetails;
    }
    getBodyText(issueDetails, filter, includeFilter) {
        const filterFunc = (key) => {
            if (!filter) {
                return true;
            }
            const hasFilter = key.toLowerCase().includes(filter);
            return includeFilter ? hasFilter : !hasFilter;
        };
        return Object.keys(issueDetails)
            .filter(filterFunc)
            .reduce((bodyStr, key) => bodyStr + (issueDetails[key] ? `${key}: ${issueDetails[key]}\n\n` : ''), '');
    }
    getMailLink(error) {
        const issueDetails = this.getIssueDetails(error);
        const currentApp = issueDetails.Application;
        const mailToUrl = new URL(`mailto:${ISSUE_REPORT_EMAIL_ADDRESS}`);
        mailToUrl.searchParams.set('subject', decodeURIComponent(`Content Platform App Suite${currentApp ? ' - ' + currentApp : ''}`));
        const bodyText = this.getBodyText(issueDetails, 'error', false) +
            `\nPlease describe your issue below in as much detail as you can along with any screenshots:\n\n\n\n` +
            this.getBodyText(issueDetails, 'error', true);
        mailToUrl.searchParams.set('body', decodeURIComponent(bodyText));
        return mailToUrl.toString().replace(new RegExp(/\+/, 'g'), ' ');
    }
    getReportIssueWithErrorMailLink(error) {
        return this.getMailLink(error);
    }
    getReportIssueMailLink() {
        return this.getMailLink();
    }
    reportIssue() {
        this.logger.warn('Reporting Issue');
        window.location.href = this.getReportIssueMailLink();
    }
    reportIssueWithError(error) {
        this.logger.warn('Reporting Issue with Error', { error: error.message });
        window.location.href = this.getReportIssueWithErrorMailLink(error);
    }
    static { this.ɵfac = function IssueReportingService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || IssueReportingService)(i0.ɵɵinject(i1.LoggerService), i0.ɵɵinject(REPORT_PARAM_TRANSFORMERS)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: IssueReportingService, factory: IssueReportingService.ɵfac }); }
}
//# sourceMappingURL=issue-reporting.service.js.map